import { buildingQueryKey } from "ApiLayer/Building/queryBuildingModel";
import queryUnpublishPlan from "ApiLayer/CustomPlans/queryUnpublishPlan";
import { useAccessToken } from "hooks/useAccessToken";
import useAlert from "hooks/useAlert";
import { useMutation, useQueryClient } from "react-query";
import useFiltersetState from "recoilStore/Filters/useFilterset";
import { showMutationAlert } from "utils/helpers";

export interface UnpublishPlanPayload {
    planId: string;
    buildingModelUid: string;
}

export const useUnpublishPlan = () => {
    const accessToken = useAccessToken();
    const alert = useAlert();
    const queryClient = useQueryClient();
    const { resetState: resetFiltersetState } = useFiltersetState();

    return useMutation({
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        onSuccess: (_, variables) => {
            alert.success("Plan has been un-published.");
            queryClient.invalidateQueries([...buildingQueryKey, variables.buildingModelUid]);
            resetFiltersetState();
        },
        mutationFn: async (data: UnpublishPlanPayload) => 
            queryUnpublishPlan(accessToken, {
              planId: data.planId,
        })
    });
}
